export default __webpack_public_path__ + "dist/media/Received.3505dbe8.svg";